function parseBooleanFlag(value, fallback = true) {
  if (value === undefined || value === null || String(value).trim() === '') {
    return fallback;
  }

  const normalized = String(value).trim().toLowerCase();
  if (normalized === 'true' || normalized === '1' || normalized === 'yes' || normalized === 'on') {
    return true;
  }

  if (normalized === 'false' || normalized === '0' || normalized === 'no' || normalized === 'off') {
    return false;
  }

  return fallback;
}

export const isShopEnabled = parseBooleanFlag(process.env.REACT_APP_SHOP_ENABLED, true);
export const isCheckoutEnabled = parseBooleanFlag(process.env.REACT_APP_CHECKOUT_ENABLED, true);

